import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const NewFilesPage = lazy(() => import("./NewFilesPage"));
const ApprovalPage = lazy(() => import("./approval/ApprovalPage"));
const ShowFilePage = lazy(() => import("./ShowFilePage"));
const ShowFolderPage = lazy(() => import("./ShowFolderPage"));
const NewFolderPage = lazy(() => import("./NewFolderPage"));
const NewDocumentPage = lazy(() => import("./NewDocumentPage"));
const EditFolderPage = lazy(() => import("./EditFolderPage"));
const EditFilePage = lazy(() => import("./EditFilePage"));
const NewFileVersionPage = lazy(() => import("./NewFileVersionPage"));

const newFolderElement = (
  <Suspense fallback={<Loading />}>
    <NewFolderPage />
  </Suspense>
);

const editFolderElement = (
  <Suspense fallback={<Loading />}>
    <EditFolderPage />
  </Suspense>
);

const folderFormRoutes: RouteObject[] = [
  { path: "/files/folders/new", element: newFolderElement },
  { path: "/groups/:groupSlug/files/folders/new", element: newFolderElement },
  { path: "/files/folders/:folderId/edit", element: editFolderElement },
  {
    path: "/groups/:groupSlug/files/folders/:folderId/edit",
    element: editFolderElement,
  },
];

const newDocumentElement = (
  <Suspense fallback={<Loading />}>
    <NewDocumentPage />
  </Suspense>
);

const newDocumentRoutes: RouteObject[] = [
  { path: "/files/documents/new", element: newDocumentElement },
  {
    path: "/groups/:groupSlug/files/documents/new",
    element: newDocumentElement,
  },
];

const newFileVersionElement = (
  <Suspense fallback={<Loading />}>
    <NewFileVersionPage />
  </Suspense>
);

const newFileVersionRoutes: RouteObject[] = [
  { path: "/files/:fileId/versions/new", element: newFileVersionElement },
  {
    path: "/groups/:groupSlug/files/:fileId/versions/new",
    element: newFileVersionElement,
  },
];

const editFileElement = (
  <Suspense fallback={<Loading />}>
    <EditFilePage />
  </Suspense>
);

const editFileRoutes: RouteObject[] = [
  { path: "/files/:fileId/edit", element: editFileElement },
  {
    path: "/groups/:groupSlug/files/:fileId/edit",
    element: editFileElement,
  },
];

const showFolderElement = (
  <Suspense fallback={<Loading />}>
    <ShowFolderPage />
  </Suspense>
);

const showFolderRoutes: RouteObject[] = [
  { path: "/files", element: showFolderElement },
  { path: "/groups/:groupSlug/files", element: showFolderElement },
  { path: "/files/folders/:folderId", element: showFolderElement },
  {
    path: "/groups/:groupSlug/files/folders/:folderId",
    element: showFolderElement,
  },
  {
    path: "/files/activitystream_folders/:streamSlug",
    element: showFolderElement,
  },
  {
    path: "/groups/:groupSlug/files/activitystream_folders/:streamSlug",
    element: showFolderElement,
  },
  { path: "/files/channel_folders/:channelId", element: showFolderElement },
];

const showFileElement = (
  <Suspense fallback={<Loading />}>
    <ShowFilePage />
  </Suspense>
);

const showFileRoutes: RouteObject[] = [
  { path: "/files/:fileId", element: showFileElement },
  { path: "/groups/:groupSlug/files/:fileId", element: showFileElement },
  {
    path: "/activities/:activityId/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/appointments/:appointmentId/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/messages/:messageId/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/chat/group/:subChatId/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/chat/member/:subChatId/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/administration/members/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/administration/consumers/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/administration/industrials/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/administration/invites/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/apps/:appSlug/items/exports/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/apps/:appSlug/items/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/apps/:appSlug/items/:itemId/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/groups/:groupSlug/apps/:appSlug/items/exports/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/groups/:groupSlug/apps/:appSlug/items/files/:fileId",
    element: showFileElement,
  },
  {
    path: "/groups/:groupSlug/apps/:appSlug/items/:itemId/files/:fileId",
    element: showFileElement,
  },
];

const reactRoutes: RouteObject[] = [
  {
    path: "/files/new",
    element: (
      <Suspense fallback={<Loading />}>
        <NewFilesPage />
      </Suspense>
    ),
  },
  {
    path: "/files/approval",
    element: (
      <Suspense fallback={<Loading />}>
        <ApprovalPage />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/files/new",
    element: (
      <Suspense fallback={<Loading />}>
        <NewFilesPage />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/files/approval",
    element: (
      <Suspense fallback={<Loading />}>
        <ApprovalPage />
      </Suspense>
    ),
  },
];

export default reactRoutes
  .concat(folderFormRoutes)
  .concat(newDocumentRoutes)
  .concat(newFileVersionRoutes)
  .concat(editFileRoutes)
  .concat(showFolderRoutes)
  .concat(showFileRoutes);
